import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { AVAILABLE_MAPS, STORAGE_KEYS } from "../constants";

interface MapContextType {
  selectedMap: string;
  setSelectedMap: (mapSrc: string) => void;
  availableMaps: typeof AVAILABLE_MAPS;
}

const MapContext = createContext<MapContextType | undefined>(undefined);

/**
 * マップ選択コンテキストプロバイダー
 */
export const MapProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedMap, setSelectedMapState] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEYS.SELECTED_MAP);
    if (!saved) return AVAILABLE_MAPS[0].src;
    if (AVAILABLE_MAPS.some((m) => m.src === saved)) return saved;
    return AVAILABLE_MAPS[0].src;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEYS.SELECTED_MAP, selectedMap);
  }, [selectedMap]);

  const setSelectedMap = (mapSrc: string) => {
    setSelectedMapState(mapSrc);
  };

  return (
    <MapContext.Provider value={{ selectedMap, setSelectedMap, availableMaps: AVAILABLE_MAPS }}>
      {children}
    </MapContext.Provider>
  );
};

/**
 * マップ選択コンテキストを使用するフック
 */
export const useMapSelection = (): MapContextType => {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error("useMapSelection must be used within MapProvider");
  }
  return context;
};
